import React, { useState } from 'react';
import { BroadcastNotificationDetail } from '../../../../model/notifications/notifications';
import styles from './BannerNotification.module.scss';
import { CloseIcon } from '../../../../assets/icons';
import ToggleSlider from '../../../../common/components/xepp/toggle-slider/ToggleSlider';
import { useSetBroadcastDontShowAgainMutation } from '../../../../service/notification-service';

const STOP_METHOD_DONT_SHOW_AGAIN = 3;

interface BannerNotificationProps {
    notification: BroadcastNotificationDetail;
    onClose: () => void;
}

const BannerNotification: React.FC<BannerNotificationProps> = ({ notification, onClose }) => {
    const [dontShowAgain, setDontShowAgain] = useState(false);
    const [setBroadcastDontShowAgain] = useSetBroadcastDontShowAgainMutation();

    if (notification.turnOnOff === false || !notification.image) return null;

    const canShowToggle = notification.stopMethod === STOP_METHOD_DONT_SHOW_AGAIN;
    const isLinked = notification.bannerLinking && !!notification.bannerUrl;

    const handleDontShowAgainChange = (value: boolean) => {
        setDontShowAgain(value);
        setBroadcastDontShowAgain({ notificationId: notification.id, dontShowAgain: value });
    };

    const handleImageClick = () => {
        if (isLinked) window.location.href = notification.bannerUrl!;
    };

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={e => e.stopPropagation()}>
                <img
                    className={`${styles.image} ${isLinked ? styles.clickable : ''}`}
                    src={notification.image}
                    alt={notification.title ?? ''}
                    onClick={handleImageClick}
                />

                <div className={styles.footer}>
                    {canShowToggle ? (
                        <div className={styles.toggleRow}>
                            <ToggleSlider isActive={dontShowAgain} onChange={handleDontShowAgainChange} />
                            <span className={styles.toggleLabel}>Don't show this again</span>
                        </div>
                    ) : (
                        <span />
                    )}

                    <button
                        type="button"
                        className={styles.closeButton}
                        onClick={onClose}
                        aria-label="Close"
                    >
                        <CloseIcon className={styles.closeIcon} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BannerNotification;
